__turbopack_context__.v({
  "action": "WalletActions-module__YGvHzW__action",
  "actionRight": "WalletActions-module__YGvHzW__actionRight",
  "actions": "WalletActions-module__YGvHzW__actions",
  "copied": "WalletActions-module__YGvHzW__copied",
  "copyButton": "WalletActions-module__YGvHzW__copyButton",
  "gearIcon": "WalletActions-module__YGvHzW__gearIcon",
  "icon": "WalletActions-module__YGvHzW__icon",
  "profilePic": "WalletActions-module__YGvHzW__profilePic",
  "root": "WalletActions-module__YGvHzW__root",
  "settings": "WalletActions-module__YGvHzW__settings",
});
